import { useState, useEffect, useCallback } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiArrowLeft, FiArrowRight, FiArrowUpRight } = FiIcons;
const slides = [
  { img: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1600&q=85', kicker: 'STRENGTH', title: 'Lift with purpose', text: 'Progressive programming that meets you where you are and takes you further.' },
  { img: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=1600&q=85', kicker: 'CONDITIONING', title: 'Find your engine', text: 'Engine sessions that build capacity and leave you buzzing for the rest of the day.' },
  { img: 'https://images.unsplash.com/photo-1576678927484-cc907957088c?auto=format&fit=crop&w=1600&q=85', kicker: 'GROUP TRAINING', title: 'Stronger together', text: 'Classes that turn a room of strangers into a room of training partners.' },
  { img: 'https://images.unsplash.com/photo-1517344884509-a0c97ec11bcc?auto=format&fit=crop&w=1600&q=85', kicker: 'RECOVERY', title: 'Recover well', text: 'Mobility and recovery sessions that keep you in the game for the long run.' },
];

function Showcase() {
  const [index, setIndex] = useState(0);
  const next = useCallback(() => setIndex((i) => (i + 1) % slides.length), []);
  const prev = useCallback(() => setIndex((i) => (i - 1 + slides.length) % slides.length), []);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next]);

  return (
    <section className="showcase-section" id="showcase">
      <div className="section-head light">
        <div>
          <span className="eyebrow">Inside the club</span>
          <h2>A space built<br /><em>for the work.</em></h2>
        </div>
        <p>Every corner is designed for focus, flow and a little bit of fun. Take a look around.</p>
      </div>
      <div className="slider">
        <AnimatePresence mode="wait">
          <motion.div
            className="slide"
            key={index}
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.98 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
          >
            <div className="slide-image" style={{ backgroundImage: `url(${slides[index].img})` }} />
            <div className="slide-shade" />
            <div className="slide-copy">
              <span className="slide-kicker">{slides[index].kicker}</span>
              <h3>{slides[index].title}</h3>
              <p>{slides[index].text}</p>
              <a className="button button-lime" href={waLink(`Tell me more about ${slides[index].title}.`)} target="_blank" rel="noreferrer">
                Learn more <SafeIcon icon={FiArrowUpRight} />
              </a>
            </div>
          </motion.div>
        </AnimatePresence>
        <button className="slider-arrow prev" onClick={prev} aria-label="Previous slide"><SafeIcon icon={FiArrowLeft} /></button>
        <button className="slider-arrow next" onClick={next} aria-label="Next slide"><SafeIcon icon={FiArrowRight} /></button>
        <div className="slider-dots">
          {slides.map((_, i) => (
            <button key={i} className={i === index ? 'dot active' : 'dot'} onClick={() => setIndex(i)} aria-label={`Go to slide ${i + 1}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
export default Showcase;
